var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 16,
    height: 16,
    transform: "translate(1)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Products_Services_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Products_Services_",
    "data-name": "Products / Services ",
    clipPath: "url(#clip-Products_Services_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-1 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M0,7.309H1.895L3.352,14.6A1.824,1.824,0,0,0,5.1,16.054h7",
    transform: "translate(1.688 -5.373)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M8.8,13.82H20.172l-1.166,4.688L9.969,19.674",
    transform: "translate(-4.783 -10.158)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M16.636,45.887a1.166,1.166,0,1,1-1.166-1.166A1.166,1.166,0,0,1,16.636,45.887Z",
    transform: "translate(-8.827 -32.873)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M38.643,45.887a1.166,1.166,0,1,1-1.166-1.166A1.166,1.166,0,0,1,38.643,45.887Z",
    transform: "translate(-25.004 -32.873)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsServices);
export default __webpack_public_path__ + "static/media/Products - Services.3cbaff1a27e04d510b68ceec6d763689.svg";
export { ForwardRef as ReactComponent };